/**
 * Created by Alex Xia on 12/17/2018.
 * Description:
 * Add contact body component
 *
 * ------ maintenance history ------
 * Updated by Abner Sui on 2019/11/06, delete useless code, use two-way binding directly
 */
import { Component, OnInit, Input } from '@angular/core';
import { EntityDetailConfig } from './entity-detail.config';
import { EntityBrief } from '../../tamalelibs/models/entity-brief.model';
import { ArrayHelperService } from '../../tamalelibs/services/array-helper.service';

@Component({
    selector: 'entity-body',
    templateUrl: './entity-body.component.html',
    styleUrls: ['./entity-body.component.scss']
})
export class EntityBodyComponent implements OnInit {
    @Input() config: EntityDetailConfig;

    customMetadata: any[] = [];
    defaultRelationshipTypeName: string;

    constructor() { }

    ngOnInit() { }

    formatExternal(link) {
        const reg = new RegExp('^http');
        if (!reg.test(link)) {
            link = 'http://' + link;
        }
        return link;
    }

    getPrivacy(): Array<EntityBrief> {
        if (this.config.entity['topicMembers']) {
            const topicMembers = this.config.entity['topicMembers'];
            ArrayHelperService.sort(topicMembers, 'name');
            return topicMembers;
        } else {
            return [];
        }
    }

    getEntityTeamMembers(): Array<EntityBrief> {
        if (this.config.entity['members']) {
            const members = this.config.entity['members'];
            ArrayHelperService.sort(members, 'shortName');
            return members;
        } else {
            return [];
        }
    }

    trackByFn(index, item) {
        return item.id;
    }

}
